module.exports = __webpack_public_path__ + "static/media/Forbidden-white Icon.fc2c220a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/Forbidden-white Icon.png
// module id = 594
// module chunks = 0